<template>
  <span>
    <DocList v-if="defaultView"></DocList>
    <FileExplorer v-else></FileExplorer>
  </span>
</template>
<script>
import DocList from '@/views/docList.vue'
import FileExplorer from '@/views/FileExplorer.vue'
import { userAccess } from '@/mixins/user-access';

export default {
  name: 'FilesView',
  components: { DocList, FileExplorer },
  computed: {
    defaultView() {
      return this.$store.getters.showDefaultView;
    },
    preferredView() {
      return localStorage.getItem('preferredFileView')
    }
  },
  mixins: [userAccess],
  mounted() {
    if (this.preferredView) {
      this.$store.commit('setShowDefaultView', this.preferredView === 'table')
    } else {
      this.$store.commit('setShowDefaultView', this.defaultFileView === 'table')
    }

  }
}
</script>